"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Util_1 = require("../deprecated/Util");
class StringTemplate {
    constructor(text, keepUnresolved = false) {
        this.text = text;
        this.keepUnresolved = keepUnresolved;
        this.variables = (text.match(StringTemplate.REGEXP) || []).map((match) => match.substring(1, match.length - 1));
    }
    apply(bindings, encodeHtml = true) {
        return this.text.replace(StringTemplate.REGEXP, (match, group) => {
            let resolved = this.resolve(bindings, group);
            // Can't use truthyness check on resolved, because "" is a valid value (but untruthy)
            if (resolved === null || resolved === undefined) {
                if (this.keepUnresolved) {
                    resolved = match;
                }
                else {
                    resolved = "";
                }
            }
            else {
                if (encodeHtml) {
                    resolved = (0, Util_1.htmlEncode)(resolved);
                }
            }
            return resolved;
        });
    }
    getVariables() {
        return this.variables;
    }
    resolve(bindings, key) {
        if (bindings instanceof Map) {
            return bindings.get(key);
        }
        else {
            return bindings[key];
        }
    }
}
StringTemplate.REGEXP = /\{([\w\-\_]+)\}/gm;
exports.default = StringTemplate;
//# sourceMappingURL=StringTemplate.js.map